// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-container[data-v-6b3cb561] {\n  text-align: center;\n  margin-top: 1.5rem;\n  font-family: var(--font-family-title);\n}\n.title-container__title[data-v-6b3cb561] {\n  font-weight: bold;\n  font-size: 2rem;\n  line-height: 1.2;\n}", ""]);
// Exports
module.exports = exports;
